"use client";

import { usePathname } from "next/navigation";

interface MainContentProps {
  children: React.ReactNode;
  headerSticky?: boolean;
}

/**
 * Client component wrapper for main content that handles
 * conditional top padding based on sticky header and current route.
 *
 * On the homepage ('/'), no top padding is applied since the homepage
 * handles its own margin/padding for transparent header state.
 * On all other pages, pt-16 is applied when sticky header is enabled.
 */
export function MainContent({ children, headerSticky }: MainContentProps) {
  const pathname = usePathname();
  const isHomepage = pathname === '/';

  // Apply padding only when sticky header is enabled AND not on homepage
  const paddingClass = headerSticky && !isHomepage ? 'pt-16' : '';

  return (
    <main className={`flex-1 ${paddingClass}`}>
      {children}
    </main>
  );
}
